import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import useGetEmployeeLeaveRequests from './hooks/useGetEmployeeListValues';
import { useGetColumns } from './hooks/useGetColumns';

type Props = {
  empId: number;
};

export default function EmployeeLeaveRequests({ empId }: Props) {
  const columns = useGetColumns();
  const { data: rows, isFetching } = useGetEmployeeLeaveRequests(empId);

  return (
    <TableCRUDLayout
      getRowId={(row) => row.leaveRequestId}
      rows={rows || []}
      columns={columns}
      loading={isFetching}
      autoHeight={true}
      pageSize={25}
      editable={false}
      disableActions={true}
      FormComponent={() => null}
    />
  );
}
